var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / HN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-HN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0884E6",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0884E6",
    mask: "url(#mask-2)",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-20",
    fill: "#0E88E9",
    mask: "url(#mask-2)",
    points: "14 10.6666667 13.057191 10.942809 13.3333333 10 13.057191 9.05719096 14 9.33333333 14.942809 9.05719096 14.6666667 10 14.942809 10.942809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-20-Copy",
    fill: "#0E88E9",
    mask: "url(#mask-2)",
    points: "19.3333333 9.33333333 18.3905243 9.60947571 18.6666667 8.66666667 18.3905243 7.72385763 19.3333333 8 20.2761424 7.72385763 20 8.66666667 20.2761424 9.60947571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-20-Copy-2",
    fill: "#0E88E9",
    mask: "url(#mask-2)",
    points: "19.3333333 12 18.3905243 12.2761424 18.6666667 11.3333333 18.3905243 10.3905243 19.3333333 10.6666667 20.2761424 10.3905243 20 11.3333333 20.2761424 12.2761424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-20-Copy-3",
    fill: "#0E88E9",
    mask: "url(#mask-2)",
    points: "8.66666667 12 7.72385763 12.2761424 8 11.3333333 7.72385763 10.3905243 8.66666667 10.6666667 9.60947571 10.3905243 9.33333333 11.3333333 9.60947571 12.2761424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-20-Copy-4",
    fill: "#0E88E9",
    mask: "url(#mask-2)",
    points: "8.66666667 9.33333333 7.72385763 9.60947571 8 8.66666667 7.72385763 7.72385763 8.66666667 8 9.60947571 7.72385763 9.33333333 8.66666667 9.60947571 9.60947571"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/HN.0dd2b49af66f3c789804a2363e01642c.svg";
export { ForwardRef as ReactComponent };